import React from 'react';
import API from "../../Services/API";
import {toast} from "react-toastify";
import Toast from "../../Components/Toast";
import Loading from "../../Layouts/Loading";
import { useParams} from "react-router-dom";
import Header from "../../Layouts/Header";
import Navbar from "../../Layouts/Navbar";
import {AiOutlineAppstoreAdd} from "react-icons/ai";
import Barcode from 'react-barcode';


function OrderBatteries() {

    const {id} = useParams();
    const [isLoaded, setIsLoaded] = React.useState(false);
    const [details, setDetails] = React.useState([]);



    React.useEffect(() => {

        API.getDetails(id)
            .then((response) => {
                setDetails(response.data);
                setIsLoaded(true);

            })
            .catch((error) => {

                if(error.response) {
                    toast.error(error.response.data.message);

                }
                else {
                    toast.error(error.message);

                }
            });


    }, [id]);



    return (
        <React.Fragment>
            <Header/>

            <Navbar page="orders"/>
            <Toast/>
            {
                !isLoaded && <Loading/>
            }
            <main id="main" className="main rtl ">

                <div className="pagetitle mb-5 border-bottom pb-4">
                    <h1>
                        <AiOutlineAppstoreAdd className='ms-2'/>
                        گزارش باتری های سفارش
                    </h1>

                </div>

                <div className="col-12">

                    <div className="card">
                        <div className="card-body pt-5 table-responsive">


                            <table className="table table-striped table-hover text-center">
                                <thead>
                                <tr className='text-small-1 pb-3'>
                                    <th scope="col" className='bg-primary-subtle rounded-end-3' >#</th>
                                    <th scope="col" className='bg-primary-subtle'>کد </th>
                                    <th scope="col" className='bg-primary-subtle'>برند </th>
                                    <th scope="col" className='bg-primary-subtle'>آمپراژ</th>
                                    <th scope="col" className='bg-primary-subtle'>وضعیت</th>
                                    <th scope="col" className='bg-primary-subtle'>گارانتی</th>
                                    <th scope="col" className='bg-primary-subtle rounded-start-3'>تاریخ فروش</th>
                                </tr>
                                </thead>
                                <tbody >
                                {
                                    details?.map(  (bt , index) => {

                                        return (
                                            <tr key={bt.code} className="text-small-1">
                                                <th scope="row">{index + 1}</th>
                                                <td>
                                                    <Barcode value={bt.code} height={16} width={1} fontSize={13}/>
                                                </td>
                                                <td> {bt.brand}</td>
                                                <td>{bt.properties[0].amperage}</td>
                                                <td className='text-small-2 fw-bold'
                                                    style={{color : bt.color}}
                                                >{bt.status}</td>
                                                <td className='text-small-1'> {bt.warranty_end_date}</td>
                                                <td className='text-small-2 fw-bold text-success'>
                                                    {
                                                        bt.sale_date
                                                    }
                                                </td>
                                            </tr>
                                        )
                                    })
                                }


                                </tbody>
                            </table>


                        </div>
                    </div>
                </div>

            </main>

        </React.Fragment>
    );
}

export default OrderBatteries;